import { palette } from '@/modules/defines/styles';
import styled from 'styled-components';
import '@/modules/defines/font.css';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  width: 100%;
`;

export const Content = styled.main`
  flex: 1;
  padding: 1rem;
  background-color: #f5f5f5;
  display: flex;
  flex-direction: column;
  max-height: calc(100vh - 80px);
  overflow-y: auto;
`;

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5rem;
`;

export const SearchContainer = styled.div`
  width: 300px;
`;

export const SearchInput = styled.input`
  width: 100%;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  border: 1px solid #e2e8f0;
  font-size: 0.9rem;

  &:focus {
    outline: none;
    border-color: ${palette.main700};
    box-shadow: 0 0 0 2px rgba(74, 144, 226, 0.2);
  }

  &::placeholder {
    color: #a0aec0;
  }
`;

export const ButtonGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export const LoadingMessage = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
  font-size: 1.2rem;
  color: #666;
  font-family: 'Pretendard', -apple-system, BlinkMacSystemFont, 'Segoe UI',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizeLegibility;
`;

export const TableContainer = styled.div<{ maxHeight?: string }>`
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  overflow: auto;
  max-width: 100%;
  max-height: ${(props) => props.maxHeight || 'calc(100vh - 180px)'};
  position: relative;
`;

export const Button = styled.button<{ type?: string }>`
  padding: 0.5rem 1rem;
  background-color: ${palette.neutral700};
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.9rem;
  font-weight: 500;
  font-family: 'Pretendard', -apple-system, BlinkMacSystemFont, 'Segoe UI',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizeLegibility;

  &:hover {
    background-color: ${palette.neutral800};
  }
  ${({ type }) =>
    type === 'avnfr'
      ? `
    background-color: ${palette.mainAvnfr};
    &:hover {
      background-color: ${palette.mainAvnfrHover};
    }
  `
      : type === 'resom'
      ? `
    background-color: ${palette.main900};
    &:hover {
      background-color: ${palette.main700};
    }
  `
      : ''}
`;

export const DeleteButton = styled(Button)`
  background-color: #e53e3e;

  &:hover {
    background-color: #c53030;
  }
`;

export const Table = styled.table`
  width: 100%;
  min-width: 1200px;
  border-collapse: collapse;
  font-family: 'Pretendard', -apple-system, BlinkMacSystemFont, 'Segoe UI',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizeLegibility;

  th,
  td {
    padding: 0.75rem;
    text-align: left;
    border-bottom: 1px solid #e2e8f0;
    white-space: nowrap;
  }

  th {
    background-color: #f8fafc;
    font-weight: 600;
    color: #1e293b;
    position: sticky;
    top: 0px;
    z-index: 1;
    user-select: none;
    transition: background-color 0.2s;

    &:hover {
      background-color: #f1f5f9;
    }
  }

  thead {
    position: sticky;
    top: 0px;
    z-index: 1;
    background-color: white;
  }

  tr:hover {
    background-color: #f8fafc;
  }
`;

export const Modal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

export const ModalContent = styled.div`
  background-color: white;
  padding: 2rem;
  border-radius: 8px;
  width: 400px;
  max-width: 90%;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  p {
    margin-bottom: 0.5rem;
    font-weight: 500;
  }
  h3 {
    margin-top: 0;
    color: ${palette.systemRed};
    font-weight: 600;
  }
`;

export const ModalButtons = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
  margin-top: 1rem;
`;

export const SelectionCount = styled.span`
  display: flex;
  align-items: center;
  font-size: 0.8rem;
  color: #4f4f4f;
  margin: 0 0.5rem;
`;

/////

export const SectionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.8rem;
  overflow-y: auto;
  min-height: 0;
`;

export const SectionContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const SectionHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  gap: 0.6rem;
  margin-bottom: 0.6rem;
`;
export const SectionTitle = styled.div`
  font-size: 1.5rem;
  font-weight: 800;
  font-family: 'Pretendard', -apple-system, BlinkMacSystemFont, 'Segoe UI',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizeLegibility;
`;

export const SectionSubTitle = styled.div`
  font-size: 0.9rem;
  font-weight: 400;
  font-family: 'Pretendard', -apple-system, BlinkMacSystemFont, 'Segoe UI',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizeLegibility;
`;

export const SectionContent = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${palette.white};
  border-radius: 0.5rem;
  padding: 1rem;
  width: 100%;
  height: auto;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
`;
